import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();


$(function () {
    $('[data-nav]').each(function () {
        $(this).on('change', function (e) {
            e.preventDefault();
            location.hash = $(this).val();
        });
    });

    $('[data-expander]').each(function () {
        $(this).on('click', function (e) {
            e.preventDefault();
            const id = $(this).attr('data-expander');
            const els = document.querySelectorAll(`[data-expander-target="${id}"]`);

            els.forEach((el) => {
                if (el.style.display !== 'none') {
                    this.innerText = 'Read More';
                    el.style.display = 'none';
                } else {
                    this.innerText = 'Read Less';
                    el.style.display = 'inline';
                }
            });
        });
    });
});


window.onload = () => {
    const scrollNavEl = document.querySelector('.scroll-nav');

    const options = {
        root: null,
        rootMargin: '-2px',
        threshold: [0.0, 0.5, 1.0],
    };

    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
                // scrollNavEl.style.display = 'none';
                scrollNavEl.classList.remove('is-visible');
            } else {
                scrollNavEl.classList.add('is-visible');
                // scrollNavEl.style.display = 'grid';
            }
        });
    };
    const observer = new IntersectionObserver(callback, options);

    observer.observe(document.getElementById('js-observe'));
};
